/** Session key holding the timestamp of the last reload we triggered. */
const LAST_RELOAD_KEY = "kk:stale-chunk-reload";
/**
 * If a reload did not fix things within this window, the chunk is genuinely
 * broken rather than stale - reloading again would just spin.
 */
const MIN_RELOAD_INTERVAL_MS = 60_000;

/**
 * A deploy replaces every hashed asset, so a session started before it asks for
 * chunks that no longer exist. Retrying the import cannot fix that; only a
 * reload, which picks up the new index.html. Vite fires `vite:preloadError`
 * whenever a dynamic import fails, so handle it once for every lazy chunk in
 * the app.
 *
 * When we do not reload, the event is left unprevented so the error keeps
 * bubbling into the component's own retry and error handling.
 */
export function reloadOnStaleChunk() {
  globalThis.addEventListener("vite:preloadError", (event) => {
    const lastReload = Number(sessionStorage.getItem(LAST_RELOAD_KEY) ?? 0);
    if (Date.now() - lastReload < MIN_RELOAD_INTERVAL_MS) return;

    sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
    event.preventDefault();
    globalThis.location.reload();
  });
}
